import React from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { MoreHorizontal, Trash2 } from 'lucide-react'

interface PostActionsMenuProps {
  canDelete: boolean
  onDelete: () => void
}

const PostActionsMenu: React.FC<PostActionsMenuProps> = ({ canDelete, onDelete }) => {
  if (!canDelete) return null
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none"
        aria-label="Post actions"
      >
        <MoreHorizontal className="h-5 w-5" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className="z-10 min-w-[140px] rounded-md border border-gray-200 bg-white p-1 shadow-md"
        >
          <DropdownMenu.Item
            onSelect={onDelete}
            className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-red-600 outline-none hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
            Delete
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

export default PostActionsMenu
